module.exports = __webpack_public_path__ + "static/media/polygonInactive.eb442a29.png";